"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PageBanner = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
var _hooks = require("../../../hooks");
var _Icon = require("../Icons/PetSure/Icon");
var _InputCheckbox = require("../../Forms/FormElements/Checkbox/InputCheckbox");
require("./banners.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DefaultPageBannerState = {
  shouldDisplay: true
};
const PageBanner = _ref => {
  let {
    animation = 'none',
    autoHide = true,
    autoHideDelay = 3,
    children,
    displayMode = 'fixed',
    bannerFormContext,
    footer = '',
    header = '',
    icon = 'info',
    id,
    position = 'top',
    type = 'info',
    showAcknowledgeCheck = true,
    customTrackingData,
    customTrackingEvents
  } = _ref;
  const StorageKey = "pageBanner_".concat(id);
  const StorageValue = localStorage.getItem(StorageKey);
  const UserPreferences = StorageValue && JSON.parse(StorageValue);
  const closeBannerButton = (0, _react.useRef)(null);
  const hookFormContext = (0, _reactHookForm.useFormContext)();
  const fieldFormContext = bannerFormContext || hookFormContext;
  const {
    shouldDisplay
  } = UserPreferences || DefaultPageBannerState;
  const [isVisible, setVisibility] = (0, _react.useState)(shouldDisplay);
  const autoHideCssClass = autoHide ? "autoHide_".concat(autoHideDelay) : 'noAutoHide';
  const animationCssClass = "".concat(autoHideCssClass, "_").concat(animation);
  (0, _hooks.useTracking)({
    elementRef: closeBannerButton,
    trackingProps: {
      label: 'Banner close button',
      field: {
        inputType: 'button'
      }
    },
    customTrackingData,
    customTrackingEvents
  });
  if (isVisible) {
    return /*#__PURE__*/_react.default.createElement("aside", {
      className: "pageBanner ".concat(showAcknowledgeCheck ? 'withAcknowledgeCheck' : '', " ").concat(type, " ").concat(position, " ").concat(displayMode, " ").concat(animationCssClass)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "pageBannerMainIcon"
    }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      icon: icon
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "pageBannerContent"
    }, children));
  }
  return null;
};
exports.PageBanner = PageBanner;
PageBanner.propTypes = {
  animation: _propTypes.default.oneOf(['slide', 'grow', 'none']),
  autoHide: _propTypes.default.bool,
  autoHideDelay: _propTypes.default.oneOf([1, 3, 5, 10]),
  // eslint-disable-next-line react/forbid-prop-types
  bannerFormContext: _propTypes.default.any,
  displayMode: _propTypes.default.oneOf(['fixed', 'inline']),
  children: _propTypes.default.node.isRequired,
  footer: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  header: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  icon: _propTypes.default.string,
  id: _propTypes.default.string.isRequired,
  position: _propTypes.default.oneOf(['top', 'center']),
  type: _propTypes.default.oneOf(['alert', 'info', 'warn', 'error', 'success']),
  showAcknowledgeCheck: _propTypes.default.bool,
  // eslint-disable-next-line react/forbid-prop-types
  customTrackingData: _propTypes.default.any,
  customTrackingEvents: _propTypes.default.arrayOf(_propTypes.default.string)
};
var _default = exports.default = PageBanner;